/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostVideoMultiPartUploadSignedurl200ResponsePartsInner } from './PostVideoMultiPartUploadSignedurl200ResponsePartsInner';
import {
    PostVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSON,
    PostVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSONTyped,
    PostVideoMultiPartUploadSignedurl200ResponsePartsInnerToJSON,
} from './PostVideoMultiPartUploadSignedurl200ResponsePartsInner';

/**
 * 
 * @export
 * @interface PostVideoMultiPartUploadSignedurl200Response
 */
export interface PostVideoMultiPartUploadSignedurl200Response {
    /**
     * 
     * @type {string}
     * @memberof PostVideoMultiPartUploadSignedurl200Response
     */
    uploadId?: string;
    /**
     * 
     * @type {Array<PostVideoMultiPartUploadSignedurl200ResponsePartsInner>}
     * @memberof PostVideoMultiPartUploadSignedurl200Response
     */
    parts?: Array<PostVideoMultiPartUploadSignedurl200ResponsePartsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof PostVideoMultiPartUploadSignedurl200Response
     */
    otpVerifyResult: boolean;
}

/**
 * Check if a given object implements the PostVideoMultiPartUploadSignedurl200Response interface.
 */
export function instanceOfPostVideoMultiPartUploadSignedurl200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "otpVerifyResult" in value;

    return isInstance;
}

export function PostVideoMultiPartUploadSignedurl200ResponseFromJSON(json: any): PostVideoMultiPartUploadSignedurl200Response {
    return PostVideoMultiPartUploadSignedurl200ResponseFromJSONTyped(json, false);
}

export function PostVideoMultiPartUploadSignedurl200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostVideoMultiPartUploadSignedurl200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uploadId': !exists(json, 'uploadId') ? undefined : json['uploadId'],
        'parts': !exists(json, 'parts') ? undefined : ((json['parts'] as Array<any>).map(PostVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSON)),
        'otpVerifyResult': json['otpVerifyResult'],
    };
}

export function PostVideoMultiPartUploadSignedurl200ResponseToJSON(value?: PostVideoMultiPartUploadSignedurl200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uploadId': value.uploadId,
        'parts': value.parts === undefined ? undefined : ((value.parts as Array<any>).map(PostVideoMultiPartUploadSignedurl200ResponsePartsInnerToJSON)),
        'otpVerifyResult': value.otpVerifyResult,
    };
}

